// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as UseIsPLP$Showside from "../hook/UseIsPLP.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as LauncherItem$Showside from "./LauncherItem.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
import * as LauncherContent$Showside from "./LauncherContent.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ScrollRestoration$Showside from "../utils/ScrollRestoration.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as UseFirstAndLastCard$Showside from "../hook/UseFirstAndLastCard.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
function useTabs(enabledOpt, category, key) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var match = CartContextProvider$Showside.useCart(undefined);
  var cart = match.cart;
  var favorites = Favorites$Showside.useFavorites(undefined);
  var match$1 = UserSavedProductsProvider$Showside.use(undefined);
  var history = match$1.history;
  var match$2 = LocationConfig$Showside.use(undefined);
  var namespace = match$2.namespace;
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var allTab = React.useMemo(function () {
    if (enabled) {
      return UseFirstAndLastCard$Showside.getSmartCard(undefined, true, true, category);
    }
  }, [category.id, key]);
  var hasAnyItems = function (category) {
    var match = Category$Showside.ExternalConnection.getConnection(category);
    if (match !== undefined && typeof match === "number") {
      switch (match) {
        case /* History */0:
          return history.value.length !== 0;
        case /* Favorites */1:
          return favorites.count > 0;
        case /* StoreCart */2:
          return cart.itemCount > 0;
      }
    }
    if (Category$Showside.hasAnyItems(category)) {
      return true;
    } else {
      return Belt_Option.isSome(Category$Showside.Link.getCardLink(category));
    }
  };
  var tabs = React.useMemo(function () {
    if (enabled) {
      return Belt_Array.keep(Belt_Array.keep(Belt_Array.concat(Belt_Array.keepMap([allTab], function (a) {
        return a;
      }), Category$Showside.getChildren(category)), function (category) {
        return category.visibleInMenuBar;
      }), hasAnyItems);
    } else {
      return [];
    }
  }, [category.id, key, history.value, favorites.count, cart.itemCount]);
  var restorationId = "tab-restoration-" + category.id;
  var restoration = ScrollRestoration$Showside.useScrollRestoration(restorationId);
  var getInitialTab = function (previousTab) {
    var i = restoration.position;
    var index;
    index = typeof i === "number" ? enabled ? 0 : undefined : i.TAG === /* Pixels */0 ? enabled ? 0 : undefined : enabled ? i._0 : enabled ? 0 : undefined;
    if (index === undefined) {
      return previousTab;
    }
    var c = Belt_Array.get(Belt_Array.keep(tabs, hasAnyItems), index);
    if (c !== undefined) {
      return c;
    } else {
      return previousTab;
    }
  };
  var match$4 = React.useState(function () {
    return getInitialTab(undefined);
  });
  var setActiveTab = match$4[1];
  var activeTab = match$4[0];
  React.useEffect(function () {
    Curry._1(setActiveTab, getInitialTab);
  }, [key, RouterProvider$Showside.toString(match$3.route)]);
  var setActiveTab$1 = React.useCallback(function (category) {
    var index = Belt_Array.getIndexBy(tabs, function (category0) {
      return category0.id === category.id;
    });
    if (index !== undefined) {
      ScrollRestoration$Showside.setCurrentScroll(namespace, restorationId, {
        TAG: /* Index */1,
        _0: index
      });
    }
    Curry._1(setActiveTab, function (param) {
      return category;
    });
  }, [tabs, setActiveTab]);
  return React.useMemo(function () {
    return {
      activeTab: activeTab,
      setActiveTab: setActiveTab$1,
      allTab: allTab,
      tabs: tabs
    };
  }, [activeTab, setActiveTab$1, allTab, tabs, key]);
}
var defaultSettings = {
  layout: /* Labels */0,
  size: /* Medium */1,
  position: /* Top */0,
  align: /* Left */0
};
function SectionTabs(Props) {
  var category = Props.category;
  var index = Props.index;
  var tabs = Props.tabs;
  var activeTab = Props.activeTab;
  var settingsOpt = Props.settings;
  var onTabChange = Props.onTabChange;
  var description = Props.description;
  var children = Props.children;
  var maxWidth = Props.maxWidth;
  var padding = Props.padding;
  var settings = settingsOpt !== undefined ? settingsOpt : defaultSettings;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var isPLP = UseIsPLP$Showside.useIsPLP(undefined);
  ConfigurationProvider$Showside.use(undefined);
  var onChange = function (categoryId) {
    var category = Belt_Array.getBy(tabs, function (category) {
      return category.id === categoryId;
    });
    if (category !== undefined) {
      return Belt_Option.forEach(onTabChange, function (fn) {
        Curry._1(fn, category);
      });
    }
  };
  var match$1 = settings.layout;
  var layout;
  switch (match$1) {
    case /* Labels */0:
      layout = /* Labels */0;
      break;
    case /* PillsWithLabel */1:
      layout = /* PillsWithLabel */2;
      break;
    case /* PillsWithIcon */2:
      layout = /* PillsWithIcon */3;
      break;
    case /* PillsWithRoundedIcon */3:
      layout = /* PillsWithRoundedIcon */4;
      break;
  }
  var match$2 = settings.size;
  var match$3 = category.socialNetworkSource;
  var size = match$3 !== undefined ? /* Small */0 : match$2;
  var match$4 = settings.position;
  var match$5 = category.socialNetworkSource;
  var indicatorPosition = match$4 || match$5 !== undefined ? /* Top */0 : /* Bottom */1;
  var match$6 = settings.align;
  var centered = match$6 === 1;
  var match$7 = category.socialNetworkSource;
  var border = match$7 !== undefined ? index === 0 ? /* BorderNone */0 : /* BorderTop */2 : /* BorderBottom */1;
  var match$8 = category.socialNetworkSource;
  var indicatorThickness = match$8 !== undefined ? /* Sm */1 : /* Normal */0;
  var match$9 = category.socialNetworkSource;
  var indicatorEnabled = match$9 !== undefined ? index !== 0 : true;
  var match$10 = category.socialNetworkSource;
  var height = match$10 !== undefined ? /* Lg */1 : /* Normal */0;
  var match$11 = category.socialNetworkSource;
  var gap = match$11 !== undefined ? isMobile ? /* Lg */1 : /* Xl */2 : /* Normal */0;
  var style = Belt_Option.map(maxWidth, function (maxWidth) {
    return {
      marginRight: "auto",
      marginLeft: "auto",
      maxWidth: CSS$Showside.intToPx(maxWidth)
    };
  });
  var partial_arg = true;
  var items = Belt_Array.map(tabs, function (param) {
    return LauncherItem$Showside.fromCategory(partial_arg, param);
  });
  var match$12 = items.length;
  var items$1 = match$12 !== 1 ? isPLP ? [] : items : [];
  var renderDescription = function (param) {
    var descriptionPaddingCn = padding !== undefined ? "" : isMobile ? "px-4" : "px-8";
    var descriptionPaddingStyle = padding !== undefined ? {
      paddingRight: CSS$Showside.intToPx(padding),
      paddingLeft: CSS$Showside.intToPx(padding)
    } : undefined;
    var match = settings.align;
    var descriptionAlignmentCn;
    switch (match) {
      case /* Left */0:
        descriptionAlignmentCn = "text-left";
        break;
      case /* Center */1:
        descriptionAlignmentCn = "text-center";
        break;
      case /* Right */2:
        descriptionAlignmentCn = "text-right";
        break;
    }
    var match$1 = settings.align;
    var maxWidthCn = match$1 !== 0 ? "" : "max-w-3xl";
    return Belt_Option.mapWithDefault(description, null, function (description) {
      var tmp = {
        className: CSS$Showside.prefix(Cn.make(["text-lg text-secondary select-text", "py-2", maxWidthCn, descriptionAlignmentCn, descriptionPaddingCn]))
      };
      if (descriptionPaddingStyle !== undefined) {
        tmp.style = Caml_option.valFromOption(descriptionPaddingStyle);
      }
      return React.createElement("div", tmp, React.createElement(DynamicTruncate$Showside.make, {
        lines: 2,
        dataTestId: "category-description",
        children: Curry._1(StringUtils$Showside.stripHTML, description)
      }));
    });
  };
  var tabs$1;
  if (items$1.length !== 0) {
    var tmp = {};
    if (style !== undefined) {
      tmp.style = Caml_option.valFromOption(style);
    }
    var tmp$1 = {
      items: items$1,
      layout: layout,
      size: size,
      dataTestId: "clp-sectionheader-tab",
      centered: centered,
      className: CSS$Showside.prefix("text-secondary"),
      onChange: onChange,
      border: border,
      indicatorEnabled: indicatorEnabled,
      indicatorThickness: indicatorThickness,
      indicatorPosition: indicatorPosition,
      height: height,
      gap: gap
    };
    var tmp$2 = Belt_Option.map(activeTab, function (tab) {
      return tab.id;
    });
    if (tmp$2 !== undefined) {
      tmp$1.activeValue = Caml_option.valFromOption(tmp$2);
    }
    if (padding !== undefined) {
      tmp$1.padding = padding;
    }
    tabs$1 = React.createElement("div", tmp, settings.position === /* Bottom */1 ? renderDescription(undefined) : null, React.createElement(LauncherContent$Showside.make, tmp$1), settings.position === /* Top */0 ? renderDescription(undefined) : null);
  } else {
    tabs$1 = null;
  }
  return React.createElement(React.Fragment, undefined, settings.position === /* Top */0 ? tabs$1 : null, children, settings.position === /* Bottom */1 ? tabs$1 : null);
}
SectionTabs.displayName = "SectionTabs";
var make = SectionTabs;
export { useTabs, defaultSettings, make };
/* react Not a pure module */